import _objectSpread from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import "core-js/modules/es.error.cause.js";
export var BaseResource = /*#__PURE__*/_createClass(
// private manager:RequestManager;
function BaseResource(_ref) {
  var host = _ref.host,
    oauthToken = _ref.oauthToken,
    prefixUrl = _ref.prefixUrl,
    requesterFn = _ref.requesterFn,
    timeout = _ref.timeout,
    token = _ref.token,
    _ref$cache = _ref.cache,
    cache = _ref$cache === void 0 ? true : _ref$cache;
  _classCallCheck(this, BaseResource);
  if (!requesterFn) throw new ReferenceError("requesterFn must be passed");
  this.url = [host, prefixUrl].join("/");
  this.headers = {
    "user-agent": "gitbeaker"
  };
  this.timeout = timeout || 10 * 1000;
  if (oauthToken) this.headers.authorization = "Bearer ".concat(oauthToken);else if (token) this.headers["token"] = token;
  // this.manager=new RequestManager();
  this.requester = requesterFn(_objectSpread({}, this));
});